const BaseLocation = import.meta.env.VITE_BASE
const APIUrl = import.meta.env.VITE_API_URL
const BaseURL = import.meta.env.VITE_BASE_URL
const LoginURL = import.meta.env.VITE_LOGIN_URL

const DEFAULTS = {
	BaseLocation,
	APIUrl,
	BaseURL,
	LoginURL
}

export default DEFAULTS
